if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        this.button = this.querySelector('[data-sticky-submit]');
        this.priceEl = this.querySelector('[data-sticky-price]');
        this.onClick = this.onClick.bind(this);
      }

      connectedCallback() {
        this.target = document.getElementById(this.dataset.target);
        if (!this.target) return;

        this.button.addEventListener('click', this.onClick);

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                // Show the bar only when the real buy button is above the viewport (scrolled past)
                const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
                this.toggle(scrolledPast);
              });
            },
            { threshold: 0 }
          );
          this.observer.observe(this.target);
        } else {
          this.toggle(true);
        }

        // Mirror price + availability whenever Dawn re-renders the price block after a variant change
        const priceContainer = document.getElementById(`price-${this.sectionId}`);
        if (priceContainer && 'MutationObserver' in window) {
          this.priceObserver = new MutationObserver(() => this.syncFromMain());
          this.priceObserver.observe(priceContainer, { childList: true, subtree: true, characterData: true });
        }
        this.syncFromMain();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.priceObserver?.disconnect();
        this.button?.removeEventListener('click', this.onClick);
      }

      toggle(show) {
        this.toggleAttribute('hidden', !show);
        document.body.classList.toggle('sticky-atc-visible', show);
      }

      syncFromMain() {
        const priceContainer = document.getElementById(`price-${this.sectionId}`);
        if (priceContainer && this.priceEl) {
          const sale = priceContainer.querySelector('.price__sale .price-item--sale, .price__sale .price-item--last');
          const regular = priceContainer.querySelector('.price__regular .price-item--regular');
          const compare = priceContainer.querySelector('.price__sale s.price-item--regular');
          const isSale = priceContainer.querySelector('.price--on-sale');
          const main = isSale && sale ? sale : regular;
          if (main) {
            this.priceEl.innerHTML = '';
            this.priceEl.append(main.textContent.trim());
            if (isSale && compare) {
              const s = document.createElement('s');
              s.className = 'sticky-atc__compare';
              s.textContent = compare.textContent.trim();
              this.priceEl.append(' ', s);
            }
          }
        }
        const target = document.getElementById(this.dataset.target);
        if (target) {
          const label = target.querySelector('span')?.textContent?.trim();
          if (label) this.button.querySelector('span').textContent = label;
          this.button.toggleAttribute('disabled', target.hasAttribute('disabled'));
        }
      }

      onClick(event) {
        event.preventDefault();
        const target = document.getElementById(this.dataset.target);
        if (!target || target.hasAttribute('disabled')) return;
        target.click();
      }
    }
  );
}
